import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { AnalyticsTabContainer } from './RoutingTabs.styles.js';
import { BarChartIcon } from '@contra/icons/icons';
import { type ReactNode } from 'react';

type AnalyticsTabProps = {
  readonly children: ReactNode;
};

export const AnalyticsTab = ({ children }: AnalyticsTabProps) => {
  const isMobile = useIsMobile();
  const size = isMobile ? 16 : 19;

  return (
    <AnalyticsTabContainer>
      <BarChartIcon size={size} />
      {children}
    </AnalyticsTabContainer>
  );
};
